import initDrawer from "./initDrawer";
import initGoTopBtn from "./initGoTopBtn";
import initHeader from "./initHeader";
import initSmoothScroll from "./initSmoothScroll";
import initViewport from "./initViewport";
import initVisionKae10 from "./initVisionKae10";
import initBoilerPrinciplePopup from "./initBoilerPrinciplePopup";
import initBoilerSimulator from "./initBoilerSimulator";
import initProductBoilerSeriesCta from "./initProductBoilerSeriesCta";
import initVideoModal from "./initVideoModal";

export default function initCommonScript() {
  // viewport固定
  initViewport();

  // headerコンテンツ
  initHeader();

  // スムーススクロール
  initSmoothScroll();

  // ドロワーメニュー
  initDrawer();

  //TOPに戻る追従ボタン
  initGoTopBtn();

  // ビジョン：かえ10リスト展開
  initVisionKae10();

  // ボイラの仕組み：原理ポップアップ
  initBoilerPrinciplePopup();

  // ベストボイラ診断
  initBoilerSimulator();

  // 製品ページ下部追従CTA
  initProductBoilerSeriesCta();

  // ビデオモーダル
  initVideoModal();
}
